module.exports = __webpack_public_path__ + "img/40.99668377.jpg";